import { MXIcon } from "../Icons/Icons";
import styles from "./FeaturedTag.module.css";

export default function FeaturedTag() {
  return (
    <div className={styles.root}>
      <MXIcon /> Featured
    </div>
  );
}
